import React from "react";
import { Stack } from "@chakra-ui/core";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { i18n } from "next-i18next";

import Navbar from "~/sections/Navbar";
import Footer from "~/sections/Footer";
import FaqsHero from "~/sections/FaqsHero";
import FaqsAnswers from "~/sections/FaqsAnswers";
import StickyButtons from "~/sections/StickyButtons";
import { useTranslation } from "~/i18n/hooks";

const PlansRoute: React.FC = () => {
  const t = useTranslation();

  React.useEffect(() => {
    document.getElementsByTagName("body")[0].setAttribute("itemScope", "");
    document
      .getElementsByTagName("body")[0]
      .setAttribute("itemtype", "https://schema.org/QAPage");
  }, []);

  return (
    <Stack height="100%" minHeight="100vh" spacing={0}>
      <Head>
        <title>{t("faqs.title")}</title>
        <meta content={t("faqs.description")} name="description" />
        <meta content={t("faqs.keywords")} name="keywords" />
        <link
          href={`${process.env.URL}/preguntas-frecuentes`}
          hrefLang="x-default"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/preguntas-frecuentes`}
          hrefLang="es"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/pt/duvidas-frequentes`}
          hrefLang="pt"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/en/faqs`}
          hrefLang="en"
          rel="alternate"
        />
        <meta content={t("faqs.title")} property="og:title" />
        <meta content={t("faqs.description")} property="og:description" />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="og:image:url"
        />
        <meta content={t("faqs.title")} name="twitter:title" />
        <meta content={t("faqs.description")} name="twitter:description" />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="twitter:image"
        />
        <meta
          name="facebook-domain-verification"
          content="zkpe1pbv54w2vb37xfieodiezyc606"
        />
      </Head>
      <Navbar backgroundColor="primary.100" color="primary.900" />
      <FaqsHero />
      <FaqsAnswers />
      <Footer />
      <StickyButtons />
    </Stack>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  // Return stores so we can build a directory
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
};

export default PlansRoute;
